import { localStorageService } from './local-storage-service';

export const refreshTokenService = localStorageService('refresh_token');
